import React from "react";

function Colors_Of_The_Year() {
  return (
    <div>
      <h1>Colors_Of_The_Year Component</h1>
      <p>This is the Colors Of The Year tutorial page content.</p>
    </div>
  );
}

export default Colors_Of_The_Year;
